import { render, staticRenderFns } from "./VfVideoCard.vue?vue&type=template&id=3d40b6d8&scoped=true"
import script from "./VfVideoCard.vue?vue&type=script&lang=js"
export * from "./VfVideoCard.vue?vue&type=script&lang=js"
import style0 from "./VfVideoCard.vue?vue&type=style&index=0&id=3d40b6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40b6d8",
  null
  
)

export default component.exports